// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Button, Container, Grid, Header, Icon, Menu, Segment, Sidebar, Transition } from "semantic-ui-react";
import "./ApplicationNotification.less";
import * as i18n from "../../config/i18n";
import { ApplicationNotificationContextProvider } from "./ApplicationNotificationContextProvider";
import { ApplicationFrameContext } from "../ApplicationFrame";
import { ApplicationSessionContext } from "../ApplicationSession";
import { NotificationList, NotificationModal, NotificationService } from "../../entities/Notification";
import { getApplicationClassName } from "../utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const className = getApplicationClassName("notification");
export const ApplicationNotification = props => {
  const {
    pin,
    onPin
  } = props;
  const {
    user
  } = React.useContext(ApplicationSessionContext);
  const {
    notification: {
      open,
      setOpen
    }
  } = React.useContext(ApplicationFrameContext);
  const [notificationOpen, setNotificationOpen] = React.useState(false);
  const handleShow = React.useCallback(() => {
    if (setOpen) {
      React.startTransition(() => {
        setOpen(true);
      });
    }
  }, [setOpen]);
  const handleHide = React.useCallback(() => {
    if (!pin && !notificationOpen) {
      if (setOpen) {
        React.startTransition(() => {
          setOpen(false);
        });
      }
    }
  }, [pin, notificationOpen, setOpen]);
  const handlePin = React.useCallback(() => {
    onPin?.();
  }, [onPin]);
  const handleNotificationOpen = React.useCallback(() => {
    React.startTransition(() => {
      setNotificationOpen(true);
    });
  }, []);
  const handleNotificationClose = React.useCallback(() => {
    React.startTransition(() => {
      setNotificationOpen(false);
    });
  }, []);
  const handleClearNotifications = React.useCallback(() => {
    NotificationService.clearNotifications();
  }, []);
  const header = React.useMemo(() => /*#__PURE__*/_jsxs(Menu, {
    secondary: true,
    children: [/*#__PURE__*/_jsx(Menu.Item, {
      "data-testid": "notification.pin",
      icon: true,
      onClick: handlePin,
      children: /*#__PURE__*/_jsx(Icon, {
        name: "pin",
        color: !pin ? "red" : "black",
        style: {
          transform: `rotateZ(${pin ? 0 : 30}deg)`
        }
      })
    }), /*#__PURE__*/_jsx(Menu.Item, {
      "data-testid": "notification.header",
      children: /*#__PURE__*/_jsx(Header, {
        children: i18n.notificationHeader
      })
    }), /*#__PURE__*/_jsx(Menu.Menu, {
      position: "right",
      children: /*#__PURE__*/_jsx(Button, {
        "data-testid": "notification.trash",
        size: "mini",
        icon: "trash",
        content: "Effacer tout",
        onClick: handleClearNotifications
      })
    })]
  }), [pin, handlePin]);
  const CreateTaskIcon = React.useMemo(() => /*#__PURE__*/_jsxs(Icon.Group, {
    children: [/*#__PURE__*/_jsx(Icon, {
      name: "tasks"
    }), /*#__PURE__*/_jsx(Icon, {
      name: "add",
      color: "green",
      corner: true
    })]
  }), []);
  return React.useMemo(() => /*#__PURE__*/_jsx(ApplicationNotificationContextProvider, {
    children: /*#__PURE__*/_jsx(Sidebar, {
      className: className,
      as: Segment,
      visible: open,
      animation: pin ? "push" : "overlay",
      direction: "right",
      width: "wide",
      onShow: handleShow,
      onHide: handleHide,
      children: /*#__PURE__*/_jsxs(Container, {
        fluid: true,
        children: [header, /*#__PURE__*/_jsxs(Container, {
          fluid: true,
          children: [/*#__PURE__*/_jsx(Grid.Row, {
            stretched: true,
            style: {
              overflow: "hidden"
            },
            children: /*#__PURE__*/_jsx(Transition, {
              mountOnShow: true,
              unmountOnHide: true,
              visible: open,
              children: /*#__PURE__*/_jsx(NotificationList, {
                user: user
              })
            })
          }), /*#__PURE__*/_jsx(Grid.Row, {
            verticalAlign: "bottom",
            children: /*#__PURE__*/_jsx(Menu, {
              borderless: true,
              children: /*#__PURE__*/_jsx(NotificationModal, {
                trigger: /*#__PURE__*/_jsx(Menu.Item, {
                  "data-testid": "notification.create",
                  icon: CreateTaskIcon,
                  content: i18n.notificationCreate
                }),
                notification: {
                  type: "tache"
                },
                onOpen: handleNotificationOpen,
                onClose: handleNotificationClose
              })
            })
          })]
        })]
      })
    })
  }), [user, open, pin, header, handleShow, handleHide, handleNotificationOpen, handleNotificationClose]);
};